module.exports = __webpack_public_path__ + "img/kd_logo_full.911fde6b.svg";